var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CMessage',{attrs:{"title":"Verify email","message":"In order to use our service you need to verify your email.","link-to":{name: 'verify'},"link-label":"Verify email"}})}
var staticRenderFns = []

export { render, staticRenderFns }